"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Sentry = __importStar(require("@sentry/react"));
var ga_1 = require("../../../../app/util/ga");
var DropdownButton_1 = require("../../../widgets/DropdownButton");
var constants_1 = require("../../../../../shared/constants");
function downloadFileFromS3(format, bulkCsvIds) {
    bulkCsvIds.forEach(function (bulkCsvId) {
        try {
            window.open(bulkCsvId + "/" + constants_1.BULK_QR_DOWNLOAD_MAPPINGS[format] + "?x-source=console");
            ga_1.GAEvent("qr code bulk download", format, 'successful');
        }
        catch (e) {
            Sentry.captureMessage("qr code bulk download for " + format + " unsuccessful");
            ga_1.GAEvent('qr code bulk download', format, 'unsuccesful');
        }
    });
}
var DownloadBulkButton = function (_a) {
    var bulkCsvIds = _a.bulkCsvIds;
    var options = [
        {
            name: 'Download all',
            onClick: function () {
                downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.CSV, bulkCsvIds);
                downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.PNG, bulkCsvIds);
                downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.SVG, bulkCsvIds);
            },
        },
        {
            name: 'Links (CSV File)',
            onClick: function () {
                return downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.CSV, bulkCsvIds);
            },
        },
        {
            name: 'QR Codes (PNG)',
            onClick: function () {
                return downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.PNG, bulkCsvIds);
            },
        },
        {
            name: 'QR Codes (SVG)',
            onClick: function () {
                return downloadFileFromS3(constants_1.BULK_QR_DOWNLOAD_FORMATS.SVG, bulkCsvIds);
            },
        },
    ];
    return (react_1.default.createElement(DropdownButton_1.DropdownButton, { buttonText: "Download .zip", options: options, fullWidth: true }));
};
exports.default = DownloadBulkButton;
